import { Warning } from '@mui/icons-material';
import { ICellRendererParams } from 'ag-grid-community';
import { useInheritanceSettingsCellWarning } from 'src/hooks/inheritance-settings/useInheritanceSettingsCellWarning';

export const InheritanceSettingsWarningRenderer = (params: ICellRendererParams) => {
    const warningMessage = useInheritanceSettingsCellWarning(params);
    return warningMessage ? <Warning className="warning-icon" color="warning" /> : '';
};
